import { render, staticRenderFns } from "./discussion.vue?vue&type=template&id=1cc6d481&scoped=true&"
import script from "./discussion.vue?vue&type=script&lang=js&"
export * from "./discussion.vue?vue&type=script&lang=js&"
import style0 from "./discussion.vue?vue&type=style&index=0&id=1cc6d481&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6d481",
  null
  
)

export default component.exports